import React, { useEffect, useState } from 'react';

const Maintenance = () => {

    return (
        <div className="maintenance-content">
        <div>ただいまシステムメンテナンス中です。</div>
        <div>メンテナンス期間：</div>
        <div>2025年5月20日（火）22時 〜5月21日（水）7時予定</div>
      　<div>ご迷惑おかけいたしますが、今しばらくお待ちください。</div>
      </div>
    );
};

export default Maintenance;
